import { createDataMapper } from '@common/utils/query/dataMappers';
import {
    AuthenticationsResponse,
    BackendAuthenticationResponse,
    GetUserDataResponse,
    UserData,
} from './types';

// const SESSION_DURATION_MS = 2 * 60 * 60 * 1_000; // 2 hours * 60 min/hr * 60 sec/min * 1_000 ms/sec
const SESSION_DURATION_MS = 7 * 24 * 60 * 60 * 1_000; // 7 days since

const mapBackendAuthToFrontendAuth = (
    response: BackendAuthenticationResponse,
): AuthenticationsResponse => {
    const loginTime = Date.now();
    const sessionExpiryTime = loginTime + SESSION_DURATION_MS;

    return {
        loginTime,
        sessionExpiryTime,
        token: response.token,
    };
};

export const transformAuth = createDataMapper<
    BackendAuthenticationResponse,
    AuthenticationsResponse
>(mapBackendAuthToFrontendAuth, false);

const mapBackendUserDataToFrontendUserData = (
    backendUserData: GetUserDataResponse,
): UserData => {
    return {
        id: backendUserData.id,
        username: backendUserData.username,
        email: backendUserData.email,
    };
};

export const transformUserData = createDataMapper<
    GetUserDataResponse,
    UserData
>(mapBackendUserDataToFrontendUserData, false);
